export default {
    data() {
        return {
            citys: [],
            table: 'zj',
            datas: {
                add: {
                }
            },
            r: {

            }
        };
    },

    created() {

        this._load();

    },
    methods: {
        _row_click(row) {


            console.log(row);

            this.$emit('row_click', row);

        },

    },
};